import { render, staticRenderFns } from "./before-you-go-modal.vue?vue&type=template&id=2a3e6f80&"
import script from "./before-you-go-modal.vue?vue&type=script&lang=js&"
export * from "./before-you-go-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports